<template>
  <el-container style="height: 100%">
    <el-header
      style="padding: 0px;box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.4);z-index: 1;"
      :height="headerHeight"
    >
      <el-menu
        class="_layout-header my-left-menu"
        router
        mode="horizontal"
        text-color="#fff"
        :default-active="modulePath"
        ref="elHeader"
      >
        <el-menu-item
          v-for="m in $store.state.user.routers.slice(0, maxShowHeaderMenu)"
          :index="reback(m)"
          :key="m.meta.id"
        >
          {{ m.meta.title }}
        </el-menu-item>
        <el-submenu
          index="/more"
          v-if="$store.state.user.routers.length > maxShowHeaderMenu"
        >
          <template slot="title">更多</template>
          <el-menu-item
            v-for="m in $store.state.user.routers.slice(maxShowHeaderMenu)"
            :index="m.path"
            :key="m.meta.id"
          >
            {{ m.meta.title }}
          </el-menu-item>
        </el-submenu>
        
        <el-submenu index="/my" class="head-rgt">
          <template slot="title">{{ $store.state.user.name }}</template>
          <el-menu-item index="/my/setting" >配置</el-menu-item>
          <el-menu-item index="" @click="logout">注销</el-menu-item>
        </el-submenu>

        <el-submenu index="/pifu" class="head-rgt">
          <template slot="title">皮肤切换</template>
          <el-menu-item index="1" @click="checkTheme('dark')">极夜蓝</el-menu-item>
          <el-menu-item index="2" @click="checkTheme('light')">月光白</el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="/lang" class="head-rgt">
          <template slot="title">语言选择</template>
          <el-menu-item index="3" @click="checkLang('zhcn')">中文</el-menu-item>
          <el-menu-item index="4" @click="checkLang('en')">英文</el-menu-item>
        </el-submenu> -->
      </el-menu>
    </el-header>
    <el-container
      v-if="
        modulePath == '/gis' ||
        modulePath == '/video' ||
        modulePath == '/videoMonitoring' ||
        modulePath == '/baojing' ||
        modulePath == '/gas' ||
        modulePath == '/bswScreen' ||
        modulePath == '/xixun_iframe' ||
        modulePath == '/kalaite_iframe' ||
        modulePath == '/yangbang_iframe' ||
        modulePath == '/chargeNeoFrame' ||
        modulePath == '/chargePileFrame' ||
        modulePath == '/AiVideo' ||
        modulePath == '/soil' ||
        modulePath == '/ap'
      "
      class="main_box"
    >
      <el-container>
        <router-view />
      </el-container>
    </el-container>
    <el-container v-else class="box_right">
      <el-aside
        class="my-aside"
        style="width: 200px;box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.12);z-index: 1"
      >
        <el-scrollbar class="_scroll">
          <el-menu
            class="_layout-nav"
            :default-active="$route.path"
            :default-openeds="openedMenus"
            router
            ref="menu"
            style="border: none"
            @select="select"
          >
            <el-menu-tree
              v-for="menu in $store.state.user.routers"
              v-show="menu.path == modulePath"
              :menus="menu.children || []"
              :key="menu.path"
            ></el-menu-tree>
          </el-menu>
        </el-scrollbar>
      </el-aside>
      <el-container>
        <el-main style="padding: 25px">
          <el-breadcrumb separator="/" style="margin-bottom: 20px">
            <template v-for="m in $route.matched">
              <el-breadcrumb-item
                v-if="!m.meta.menuHide"
                :key="m.meta.id"
                :to="m.path"
                @click.native="itemClick(m.path)"
              >
                {{ m.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
          <router-view style="margin-bottom: 25px" />
        </el-main>
        <!-- <el-footer height='35px' class='footer'>Copyright © {{ new Date().getFullYear() }} <em v-html="$store.state.sys.company"></em>
				</el-footer> -->
      </el-container>
    </el-container>
  </el-container>
</template>
<script>
import ElMenuTree from "@/components/common/elMenuTree";
export default {
  components: { ElMenuTree },
  data() {
    return {
      operationDialog: false,
      contactDialog: false,
      headerHeight: "60px",
      openedMenus: [],
      currentMenus: [],
      menuPath: "",
      maxShowHeaderMenu: 0,
      value: true
    };
  },
  created() {
    let meta = document.getElementsByTagName("meta");
    meta[1].content = "";
    this.maxShowHeaderMenu = Math.floor(document.body.clientWidth / 100) - 3;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // let modulePath = vm.modulePath
      // let currentModule = vm.$store.state.user.menus.find(m=>m.path==modulePath)
      // let currentMenus =  currentModule?currentModule.children:[]
      // vm.openedMenus = []
      // vm.currentMenus = [...currentMenus]
      // vm.menuPath = to.path
      // setTimeout(()=>{
      // 	console.log('asdf')
      // },0)
    });
  },
  mounted() {
    this.resize();
    window.addEventListener("resize", this.resize);
  },
  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    logout() {
      this.$confirm("您确定注销退出系统吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.$store.dispatch("logout");
      });
    },
    select(index, indexPath) {
      //console.log(this.$refs.menu.defaultActive)
    },
    reback(m) {
      if(m.children.length>1){
        return m.path+'/'+m.children[1].path
      }
      return m.path
    },
    resize() {
      this.headerHeight = this.$refs.elHeader.$el.clientHeight + "px";
    },
    checkTheme(val) {
      document.getElementById("style").setAttribute("href","/static/css/"+val+"/index.css");
	    localStorage.setItem("style","/static/css/"+val+"/index.css")
      this.$eventBus.$emit("mapStyle", val); 
    },
    checkLang(val) {
      localStorage.setItem('lang', val)
      location.reload()
    },
    itemClick(e) {
      // console.log('itemClick',e)
      // console.log(this.$route.path)
      // this.menuPath = this.$route.path
      // setTimeout((v)=>{
      // 	console.log(this.$route.path)
      // 	this.menuPath = '/yyzx'
      // 	console.log(v)
      // },1000)
    },
  },
  computed: {
    modulePath() {
      let e =
        this.$route.matched.length == 0
          ? this.$route.path
          : this.$route.matched[0].path;
      return e ? e : "/";
    },
  },
};
</script>
<style lang='less'>
._scroll {
  height: 100%;
  .el-scrollbar__wrap {
    overflow-x: auto;
  }
}
.footer {
  text-align: center;
  border-top: 1px solid #ebeef5;
  font-size: 12px;
  color: #999;
  line-height: 34px;
  em {
    font-style: normal;
  }
  a {
    color: #777;
  }
}
</style>